import { generateCustomId } from "@/utils/generateCustomId";

export function mergeCombosWithPreservedData(newCombos, oldCombos) {
  const optionsMatch = (a, b) => {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key) => a[key] === b[key]);
  };

  const defaultMeta = {
    priceDirty: false,
    compareAtDirty: false,
    costDirty: false,
    inventoryDirty: false,
    skuDirty: false,
    barcodeDirty: false,
    trackInvDirty: false,
  };

  return newCombos.map((newCombo) => {
    const existing = oldCombos.find((old) =>
      optionsMatch(old.options, newCombo.options)
    );

    return {
      ...newCombo,
      variantId: newCombo?.variantId ?? existing?.variantId ?? null,
      variantUiId: existing?.variantUiId || newCombo?.variantUiId || generateCustomId({ prefix: "variant-" }),
      // Pricing: prefer existing edits, then incoming seed, else default
      price: existing?.price ?? newCombo?.price ?? "",
      compareAtPrice: existing?.compareAtPrice ?? newCombo?.compareAtPrice ?? "",
      costPerItem: existing?.costPerItem ?? newCombo?.costPerItem ?? "",
      // Inventory & identifiers: prefer existing, then incoming seed, else default
      inventoryQuantity: existing?.inventoryQuantity ?? (newCombo?.inventoryQuantity ?? 0),
      sku: existing?.sku ?? newCombo?.sku ?? "",
      barcode: existing?.barcode ?? newCombo?.barcode ?? "",
      trackInventory: existing?.trackInventory ?? (newCombo?.trackInventory ?? true),
      // Image override: prefer existing, else incoming seed, else default
      imageOverride: existing?.imageOverride ?? newCombo?.imageOverride ?? "",
      meta: existing?.meta ? { ...defaultMeta, ...existing.meta } : { ...defaultMeta },
    };
  });
}
